var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.053,
    height: 21.251,
    viewBox: "0 0 92.053 21.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(-37.766 -316.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982-2",
    "data-name": "Group 982",
    transform: "translate(37.766 316.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M544.048,355.982c0-.543,0-1.053-.017-1.525a9.3,9.3,0,0,0-.132-1.327,4.476,4.476,0,0,0-.372-1.156,3.745,3.745,0,0,0-.734-1.017,4.7,4.7,0,0,0-1.491-1.028,4.891,4.891,0,0,0-1.905-.357,4.961,4.961,0,0,0-1.913.357,4.66,4.66,0,0,0-1.5,1.023,3.705,3.705,0,0,0-.731,1.017,4.426,4.426,0,0,0-.366,1.156,9.257,9.257,0,0,0-.127,1.327c-.012.471-.018.982-.015,1.525s0,1.049.015,1.524a9.257,9.257,0,0,0,.127,1.326,4.423,4.423,0,0,0,.366,1.156,3.752,3.752,0,0,0,.731,1.017,4.607,4.607,0,0,0,1.5,1.021,4.926,4.926,0,0,0,1.913.359,4.859,4.859,0,0,0,1.905-.359A4.641,4.641,0,0,0,542.793,361a3.783,3.783,0,0,0,.734-1.017,4.475,4.475,0,0,0,.372-1.156,9.257,9.257,0,0,0,.13-1.323c.015-.474.021-.982.018-1.524Zm-2.46,0c0,.6-.009,1.1-.029,1.5a7.632,7.632,0,0,1-.1.976,2.411,2.411,0,0,1-.2.622,1.79,1.79,0,0,1-.293.436,1.89,1.89,0,0,1-.666.488,2.276,2.276,0,0,1-.909.184,2.317,2.317,0,0,1-.914-.184,1.9,1.9,0,0,1-.683-.488,1.722,1.722,0,0,1-.293-.436,2.336,2.336,0,0,1-.185-.622,8.153,8.153,0,0,1-.1-.976q-.027-.6-.026-1.5c0-.6.009-1.1.026-1.5a8.155,8.155,0,0,1,.1-.976,2.337,2.337,0,0,1,.185-.622,1.735,1.735,0,0,1,.293-.436,1.906,1.906,0,0,1,.683-.488,2.262,2.262,0,0,1,.914-.184,2.226,2.226,0,0,1,.909.184,1.9,1.9,0,0,1,.666.488,1.8,1.8,0,0,1,.293.436,2.41,2.41,0,0,1,.2.622,7.7,7.7,0,0,1,.1.976c.021.4.029.9.029,1.5",
    transform: "translate(-471.596 -345.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M695.984,350.66a.218.218,0,0,0-.216-.216h-2.029a.217.217,0,0,0-.216.216v7.5l-4.949-7.652c-.033-.052-.063-.061-.136-.061h-1.882a.219.219,0,0,0-.216.216v12.164a.218.218,0,0,0,.216.215h2.028a.216.216,0,0,0,.215-.215v-7.516l4.95,7.669c.034.052.061.061.136.061h1.881a.217.217,0,0,0,.216-.215Z",
    transform: "translate(-603.931 -346.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M638.283,350.66a.217.217,0,0,0-.216-.216H636.04a.217.217,0,0,0-.216.216v12.163a.217.217,0,0,0,.216.216h2.027a.217.217,0,0,0,.216-.216Z",
    transform: "translate(-559.833 -346.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M447.279,356.027c0-.605.007-1.109.024-1.51a7.778,7.778,0,0,1,.1-.976,2.134,2.134,0,0,1,3.794-.879,2.789,2.789,0,0,1,.391.89.065.065,0,0,0,.07.054h2.387c.034,0,.047-.023.041-.057a4.54,4.54,0,0,0-2.44-3.46,5.018,5.018,0,0,0-2.185-.464,4.615,4.615,0,0,0-3.4,1.38,3.644,3.644,0,0,0-1.029,1.89,17.418,17.418,0,0,0-.213,3.131,16.9,16.9,0,0,0,.213,3.13,3.651,3.651,0,0,0,1.026,1.894,4.616,4.616,0,0,0,3.4,1.379,5.028,5.028,0,0,0,2.184-.463,4.54,4.54,0,0,0,2.44-3.46c.006-.034-.007-.057-.041-.057h-2.388a.065.065,0,0,0-.07.054,2.792,2.792,0,0,1-.39.889,2.135,2.135,0,0,1-3.794-.879,7.779,7.779,0,0,1-.1-.976c-.014-.4-.021-.908-.021-1.511",
    transform: "translate(-393.099 -345.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M248.888,350.66a.217.217,0,0,0-.216-.216h-2.027a.217.217,0,0,0-.216.216v12.164a.217.217,0,0,0,.216.215h2.027a.217.217,0,0,0,.216-.215v-3.57l1.627-1.945,3.342,5.666a.136.136,0,0,0,.121.065h2.464c.113,0,.134-.07.077-.167l-4.376-7.418,4.015-4.816c.081-.1.047-.19-.08-.19h-2.693a.1.1,0,0,0-.084.039l-4.413,5.293Z",
    transform: "translate(-219.916 -346.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M350.187,360.952a2.3,2.3,0,0,1-2.176-2.317V350.66a.217.217,0,0,0-.216-.216h-2.027a.217.217,0,0,0-.216.216V358.6a4.636,4.636,0,0,0,9.269,0V350.66a.218.218,0,0,0-.216-.216h-2.028a.217.217,0,0,0-.215.216v7.975a2.3,2.3,0,0,1-2.176,2.317",
    transform: "translate(-306.444 -346.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M43.9,327l6.294,6.3,3.973-3.973a1.8,1.8,0,0,1,2.538,2.538l-5.243,5.244a1.81,1.81,0,0,1-2.538,0l-7.564-7.566v4.5a1.8,1.8,0,1,1-3.594,0V319.964a1.8,1.8,0,0,1,3.594,0v4.5l7.563-7.564a1.809,1.809,0,0,1,2.538,0l5.247,5.243a1.8,1.8,0,0,1-2.538,2.538L50.2,320.7Zm6.3-1.8h0a1.8,1.8,0,1,0,1.272.527,1.8,1.8,0,0,0-1.272-.527Z",
    transform: "translate(-37.766 -316.377)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuCoin);
export default __webpack_public_path__ + "static/media/kuCoin.f81c657a067db533f324b0109c42f487.svg";
export { ForwardRef as ReactComponent };